import React,{ useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './styles.scss';
import { history } from 'umi';



export default (props) => {
  const {isShow,ad, closeCallback,confirmClick } = props;


  if (isShow) {
    return ReactDOM.createPortal (
      <div className={styles.dialogBg}>

        <div className={styles.closeBox}>
          <div className={styles.closeButton} onClick={() =>{
            closeCallback && closeCallback();
          }}>
            <img src={require('@/assets/close.png')}/>
          </div>
          <div className={styles.line}/>
        </div>

        <div className={styles.dialogBox} onClick={()=> {}}>

          {ad && <img src={ad.image}/>}

          <div className={styles.dialogButton} onClick={()=> {
            confirmClick && confirmClick();
          }}>点击查看</div>

        </div>


      </div>
      ,document.body)
  } else {
    return null;
  }

}
